"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SubscriptionStore = /*#__PURE__*/function (_RootStore) {
  function SubscriptionStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, SubscriptionStore);
    _this = _callSuper(this, SubscriptionStore);
    _this.config = {
      model: _models.Subscription,
      deserialize: true,
      GET: {
        index: '/subscriptions',
        show: '/subscriptions/:subscriptionId',
        findByStripeSubscriptionId: '/subscriptions/find_by_stripe_subscription_id'
      },
      PUT: {
        update: '/subscriptions/:subscriptionId',
        cancel: '/subscriptions/:subscriptionId/cancel',
        updatePayments: '/subscriptions/:subscriptionId/update_payments',
        syncWithStripe: '/subscriptions/:subscriptionId/sync_with_stripe'
      },
      POST: {
        create: '/subscriptions',
        withdraw: '/subscriptions/:subscriptionId/withdraw'
      },
      DELETE: {
        destroy: '/subscriptions/:subscriptionId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(SubscriptionStore, _RootStore);
  return (0, _createClass2["default"])(SubscriptionStore, [{
    key: "cancel",
    value: function cancel(params, callback) {
      this.api(params, callback, 'PUT', 'cancel');
    }
  }, {
    key: "withdraw",
    value: function withdraw(params, callback) {
      this.api(params, callback, 'POST', 'withdraw');
    }
  }, {
    key: "updatePayments",
    value: function updatePayments(params, callback) {
      this.api(params, callback, 'PUT', 'updatePayments');
    }
  }, {
    key: "syncWithStripe",
    value: function syncWithStripe(params, callback) {
      this.api(params, callback, 'PUT', 'syncWithStripe');
    }
  }, {
    key: "findByStripeSubscriptionId",
    value: function findByStripeSubscriptionId(stripeSubscriptionId, callback) {
      this.api({
        queryStrings: {
          stripe_subscription_id: stripeSubscriptionId
        }
      }, callback, 'GET', 'findByStripeSubscriptionId');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new SubscriptionStore();